
export default function formatMessageContentImage ({
    url,
    name,
    size,
    type
}) {
    return {
        fileName: name,
        fileSize: Number(size),
        url,
        type
    }
}
